import React, { useState, useEffect } from "react";
import CompleteRegistrationBig from "./CompleteRegistrationBig";
import CompleteRegistrationSmall from "./CompleteRegistrationSmall";

// Custom hook to detect device type
function useDevice() {
	const [device, setDevice] = useState(getDeviceType());

	function getDeviceType() {
		const width = window.innerWidth;
		if (width < 768) return "mobile";
		if (width < 1024) return "tablet";
		return "desktop";
	}

	useEffect(() => {
		function handleResize() {
			setDevice(getDeviceType());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return device;
}

// Main component
export default function CompleteRegistration(props) {
	const device = useDevice();

	return (
		<div>
			{device === "mobile" && <CompleteRegistrationSmall match={props.match} history={props.history} />}
			{device === "tablet" && <CompleteRegistrationBig match={props.match} history={props.history} />}
			{device === "desktop" && <CompleteRegistrationBig match={props.match} history={props.history} />}
		</div>
	);
}
